import { Typography } from "@material-ui/core"

export const CIDTestView = ({ procedureData }: { procedureData: any }) => {
  return (
    <div>
      <Typography variant="body1">
        Test duration :{procedureData?.cid_test?.test_duration ?`${procedureData?.cid_test?.test_duration} hours`  : "N/A"} 
      </Typography>
      <Typography variant="body1">
        Test temperature :{procedureData?.cid_test?.test_temperature ? `${procedureData?.cid_test?.test_temperature} °C`: "N/A"} 
      </Typography>
      <Typography variant="body1">
        Equipment Calibration Date :{procedureData?.cid_test?.equipment_calibration_date ? procedureData?.cid_test.equipment_calibration_date.substring(0, 10) : "N/A"}
      </Typography>

      <Typography variant="body1">
        Applied Current : {procedureData?.cid_test?.applied_current ?`${procedureData?.cid_test?.applied_current} A`  : "N/A"} 
      </Typography>

      <Typography variant="body1">
        Current voltage normal : {procedureData?.cid_test?.current_normal ? procedureData?.cid_test?.current_normal : "N/A"}
      </Typography>

    </div>
  )
}






